enum ParagraphType {
    DefaultText = 1,
    QuotedText = 2,
    ThreadText = 3,
}

export default ParagraphType;
